export { MessagesOptionsItem as default };

/**
* Messages Options Item Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesOptionsItem {
  /**
   * Image Replacement
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  image_replacement;

  /**
   * Name
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  request_mdn;
}